import {
  BookOpen,
  BookMarked,
  Heart,
  ListChecks,
  Users,
  Compass,
  ArrowUpRight,
  Check,
} from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Eyebrow } from "./primitives";
import { toast } from "@/components/ui/sonner";
import { cn } from "@/lib/utils";

const SidebarItem = ({ icon: Icon, title, sub, external, done }) => (
  <button
    type="button"
    onClick={() => toast(`Opening ${title}`, { description: "This is a design prototype." })}
    className="group flex w-full items-center gap-3 rounded-lg px-2 py-2 text-left transition-colors hover:bg-secondary/70"
  >
    <Icon className="h-4 w-4 shrink-0 text-muted-foreground transition-colors group-hover:text-primary" strokeWidth={1.7} />
    <span className="min-w-0 flex-1">
      <span className="block truncate text-[14px] text-foreground/90">{title}</span>
      {sub ? <span className="block truncate text-[12px] text-muted-foreground">{sub}</span> : null}
    </span>
    {external ? <ArrowUpRight className="h-3.5 w-3.5 shrink-0 text-muted-foreground" /> : null}
    {done ? <Check className="h-3.5 w-3.5 shrink-0 text-primary" /> : null}
  </button>
);

const SidebarGroup = ({ label, children }) => (
  <div>
    <p className="eyebrow px-2">{label}</p>
    <div className="mt-2 space-y-0.5">{children}</div>
  </div>
);

export const Sidebar = ({ className }) => (
  <div className={cn("rounded-xl border border-border bg-card/50 p-4 shadow-soft", className)}>
    <SidebarGroup label="Readings">
      <SidebarItem icon={BookOpen} title="Daily Reflections" sub="AA · opens online" external />
      <SidebarItem icon={BookMarked} title="All daily readings" />
    </SidebarGroup>
    <Separator className="my-3.5 bg-border/70" />
    <SidebarGroup label="Prayers">
      <SidebarItem icon={Heart} title="Prayers" />
    </SidebarGroup>
    <Separator className="my-3.5 bg-border/70" />
    <SidebarGroup label="The Program">
      <SidebarItem icon={ListChecks} title="The Twelve Steps" done />
      <SidebarItem icon={Users} title="The Twelve Traditions" />
      <SidebarItem icon={Compass} title="The Twelve Concepts" />
    </SidebarGroup>
  </div>
);
